const ratingValues = [
  {
    value: '1',
    text: 'Para nada'
  },
  {
    value: '2',
    text: 'Un poco'
  },
  {
    value: '3',
    text: 'Medianamente'
  },
  {
    value: '4',
    text: 'Bastante'
  },
  {
    value: '5',
    text: 'Totalmente'
  }
];

const questionFooter = {
  type: 'html',
  name: 'HTML_QUESTION_FOOTER',
  html: `
  <div class="qstn-likert-label pb-5">
    <div>No me representa para nada</div>
    <div></div>
    <div>Me representa totalmente</div>
  </div>
  `
};

const questionHeader = {
  type: 'html',
  name: 'HTML_QUESTION_Header',
  html: `
  <div class="">
    <span style="font-size:16px;">
      Por favor indica en qué medida esta afirmación te representa:
    </span>
    <br />
    <br />
  </div>
  `
};

export const TestIntro = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  // showProgressBar: 'top',
  // progressBarType: 'questions',
  goNextPageAutomatic: false,
  firstPageIsStarted: false,
  showPrevButton: false,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  showQuestionNumbers: 'off',
  requiredText: `*`,
  pages: [
    {
      name: 'EE_PAGE_00_M',
      title: '',
      elements: [
        {
          type: 'html',
          name: 'HTML_DIALOG_01_DIM',
          html: `
<div class="QuestionText BorderColor">
  <span style="font-size:16px;">
    <span style="font-family:arial,helvetica,sans-serif;">
      <h3>Sección 5/5</h3>
    </span>
    <br />
    A continuación se presentan una serie de afirmaciones respecto de la forma en que te sientes en el colegio y en relación a tu paso a la enseñanza media. Para cada afirmación, indica si refleja la forma en que piensas o te sientes. Para esto, utilizaremos la siguiente escala que va de 1 a 5, donde 1 es “No me representa para nada” y 5 es “Me representa totalmente”:
    <br />
    <br />
    <div class="btn-group">
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="1" value="1"><span class="quanta_q_rating_item_text"><span>Para nada</span></span></label>
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="2" value="2"><span class="quanta_q_rating_item_text"><span>Un poco</span></span></label>
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="3" value="3"><span class="quanta_q_rating_item_text"><span>Medianamente</span></span></label>
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="4" value="4"><span class="quanta_q_rating_item_text"><span>Bastante</span></span></label>
      <label class="btn btn-primary"><input type="radio" class="sv-visuallyhidden" name="EE_00" aria-required="true" aria-label="5" value="5"><span class="quanta_q_rating_item_text"><span>Totalmente</span></span></label>
    </div>
    <div class="qstn-likert-label pb-5">
      <div>No me representa para nada</div>
      <div></div>
      <div>Me representa totalmente</div>
    </div>
  </span>
</div>
`
        }
      ]
    }
  ]
};

const ITEMS = [
  {
    code: 'RECTR_01',
    statement:
      'Si tengo algún problema en el colegio, puedo pensar en distintas cosas que hacer para solucionarlo'
  },
  {
    code: 'RECTR_02',
    statement: 'Creo que estoy haciendo las cosas bien en el colegio'
  },
  {
    code: 'RECTR_03',
    statement:
      'Puedo pensar en distintos caminos para alcanzar las metas que quiero lograr en el colegio'
  },
  {
    code: 'RECTR_04',
    statement:
      'Creo que lo que he logrado en el colegio hasta ahora me ayudará en los próximos años'
  },
  {
    code: 'RECTR_05',
    statement:
      'Tengo confianza en que podré aprender lo que me enseñen en educación media'
  },
  {
    code: 'RECTR_06',
    statement:
      'Me siento capaz de ajustar la forma en que estudio para enfrentar los nuevos desafíos académicos'
  },
  {
    code: 'RECTR_07',
    statement:
      'Soy capaz de adaptarme a los cambios que vienen en enseñanza media (como nuevos profesores, cambios de horarios, mayor exigencia, etc.)'
  },
  {
    code: 'RECTR_08',
    statement:
      'Tengo confianza en que durante la enseñanza media podré aclarar qué es lo quiero hacer en el futuro'
  },
  {
    code: 'RECTR_09',
    statement:
      'Creo que mi paso por la enseñanza media será una experiencia positiva'
  },
  {
    code: 'RECTR_10',
    statement:
      'Siempre puedo rescatar el lado positivo de las experiencias del colegio'
  },
  {
    code: 'RECTR_11',
    statement:
      'Pienso que en los próximos años en el colegio habrá más cosas buenas que malas'
  },
  {
    code: 'RECTR_12',
    statement:
      'Cuando las cosas se ponen difíciles en el colegio, me gusta pensar en que todo resultará bien'
  },
  {
    code: 'RECTR_13',
    statement:
      'Creo que soy bueno/a enfrentando los contratiempos en el colegio (como recibir una mala nota o comentarios negativos sobre un trabajo)'
  },
  {
    code: 'RECTR_14',
    statement: 'No dejo que el estrés de los estudios me afecte mucho'
  },
  {
    code: 'RECTR_15',
    statement:
      'Creo que manejo bien la presión de las pruebas y tareas escolares'
  },
  {
    code: 'RECTR_16',
    statement:
      'No permito que una mala nota afecte mi confianza en mis capacidades'
  }
];

const testInfo = {
  locale: 'es',
  title: '',
  completedHtml:
    '<div style="display: flex; justify-content: center; align-items: center; height: 40vh;"><h4>Guardando respuestas para avanzar...</h4></div>',
  startSurveyText: 'Continuar',
  showProgressBar: 'top',
  progressBarType: 'pages',
  goNextPageAutomatic: true,
  firstPageIsStarted: false,
  showPrevButton: true,
  showNavigationButtons: true,
  pageNextText: '→',
  pagePrevText: '←',
  // showQuestionNumbers: 'off',
  requiredText: ``,
  pages: ITEMS.map(item => {
    const { code, statement } = item;
    return {
      name: code,
      title: '',
      elements: [
        questionHeader,
        {
          type: 'rating',
          name: code,
          title: statement,
          isRequired: true,
          rateValues: ratingValues
        },
        questionFooter
      ]
    };
  })
};

export default testInfo;
